import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { PACKAGES, REVIEWS, SETUP, WEB_PANEL } from "../data/site";

const API = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_CONTACT = {
  whatsappNumber: "905303809300",
  whatsappDisplay: "0 530 380 93 00",
  telegram: "https://www.t.me/dolunaytv",
  telegramDisplay: "t.me/dolunaytv",
  instagram: "https://www.instagram.com/dolunaytvmedya",
  instagramDisplay: "@dolunaytvmedya",
};

const SiteContext = createContext(null);

const build = (raw) => {
  const contact = { ...DEFAULT_CONTACT, ...(raw?.contact || {}) };
  const base = `https://wa.me/${contact.whatsappNumber}`;
  const wa = (msg) => `${base}?text=${encodeURIComponent(msg)}`;
  const trial = wa("Merhaba, Dolunay TV 6 saatlik ücretsiz test talep etmek istiyorum.");
  const pk = Array.isArray(raw?.packages) ? raw.packages : PACKAGES;
  const packages = pk.map((p) => ({
    ...p,
    features: Array.isArray(p.features) ? p.features : [],
    link: p.trial ? trial : wa(`Merhaba, ${p.period ? `${p.period} ` : ""}${p.name} (${p.price}${p.unit ? ` ${p.unit}` : ""}) sipariş vermek istiyorum.`),
  }));
  const reviews = Array.isArray(raw?.reviews) ? raw.reviews : REVIEWS;
  const links = raw?.links || {};
  const guides = raw?.guides || {};
  const setup = SETUP.map((s) => {
    const g = guides[s.id] || {};
    return {
      ...s,
      url: links[s.id] || s.url,
      steps: Array.isArray(g.steps) && g.steps.length ? g.steps : s.steps,
      video: g.video || links.videos?.[s.id] || "",
    };
  });
  const webPanel = links.webPanel || WEB_PANEL;
  return { raw, contact: { ...contact, whatsapp: base }, wa, trial, packages, reviews, setup, webPanel };
};

export const SiteProvider = ({ children }) => {
  const [raw, setRaw] = useState(null);

  const reload = useCallback(() => {
    if (!API) return;
    axios.get(`${API}/api/site`).then((r) => setRaw(r.data || null)).catch(() => {});
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = useMemo(() => ({ ...build(raw), reload }), [raw, reload]);
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
